import { Flex, Heading, Image, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { ChooseLanguageModal } from 'src/pages/Login/components/ChooseLanguageModal'

const LogInHeading = () => {
  const [t] = useTranslation()

  return (
    <>
      <Flex flexDir='column'>
        <Image width={{ base: '32px', lg: '62px' }} src='assets/images/Logo.svg' alt='logo' />
        <Flex align='center' marginTop={{ base: '8px', lg: '21px' }} marginBottom='10px'>
          <Heading
            alignSelf='left'
            fontWeight='600'
            color='gray.800'
            fontFamily='Poppins'
            fontSize={{ base: '19px', lg: '32px' }}
          >
            {t('login.imperativeLogin')}
          </Heading>
          <Flex align='center' justify='flex-end' ml='auto'>
            <ChooseLanguageModal />
          </Flex>
        </Flex>
        <Text fontSize='16px' fontWeight='500' color='gray.800' marginBottom={{ base: '24px', lg: '30px' }}>
          {t('login.loginPageSentence')}
        </Text>
      </Flex>
    </>
  )
}

export default LogInHeading
